module.exports = __webpack_public_path__ + "media/assets/images/flags/rs-7c0cc268a38b91ff078505679478cba7.svg";